export default {
  id: 'vitalSign/HEART_RATE/v1',
  formSchema: {
    title: 'encounter:widget.vitalSigns.heartRate',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'integer',
        minimum: 1,
        maximum: 999,
        title: 'encounter:widget.vitalSigns.heartRate'
      }
    },
    iconClass: 'icon-activity',
    measurement: 'bpm'
  },
  uiSchema: {
    id001: { 'ui:widget': 'customI18nNumericWidget' },
    'x-customClass': 'vital-signs-widget',
    'x-cancelBtnSize': 'sm',
    'x-saveBtnSize': 'sm'
  }
};
